// eslint-disable
// This file is generated dynamically through `node prepare-locales.js`. Please do content changes in `shopify/assets/locales/*.json`, update the filter rules in `prepare-locales.js` and run `node prepare-locales.js`.

import type { Locale } from './en'

if (!window.seebergerLocales) {
  window.seebergerLocales = {}
}

window.seebergerLocales.fr = {
  general: {
    countdown: {
      remaining: 'Temps restant',
      days: 'Jours',
      hours: 'Heures',
      minutes: 'Minutes',
      seconds: 'Secondes',
    },
    forms: {
      inputs: {
        labels: {
          email: 'E-mail',
          firstName: 'Prénom',
          lastName: 'Nom de famille',
        },
        placeholders: {
          email: 'par ex., mali.exemple@example.com',
          firstName: 'par ex., Mali',
          lastName: 'par ex., Exemple',
        },
        errors: {
          email: "Veuillez remplir l'e-mail.",
          firstName: 'Veuillez remplir le prénom.',
          lastName: 'Veuillez remplir le nom de famille.',
        },
      },
      response: {
        error: {
          text: 'Veuillez vérifier votre saisie et réessayer.',
        },
        success: {
          text: (data: { firstname: string; subject: string }) =>
            `Merci pour votre message, ${data.firstname}. Nous vous contacterons dès que possible concernant "${data.subject}".`,
        },
      },
      privacy_policy: 'Politique de confidentialité',
      contact_information: 'Informations de contact',
    },
    links: {
      go_to: {
        product: (data: { productTitle: string }) =>
          `Plus d'informations sur ${data.productTitle}`,
        link: (data: { linkTitle: string }) =>
          `En savoir plus sur ${data.linkTitle}`,
      },
    },
  },
  brevo_form: {
    success: {
      title: 'Merci de votre inscription',
      text: 'Veuillez vérifier votre boîte aux lettres (y compris les spams) pour confirmer votre inscription.',
    },
    error: {
      title: 'il y a eu une erreur',
      text: 'Veuillez désactiver votre AdBlocker et vérifier votre connexion Internet.',
    },
  },
  accessibility: {
    close_notification: 'Ferme la notification',
  },
  products: {
    product: {
      options: {
        more_single: 'Plus loin',
        more_plural: 'Plus',
      },
      option_name: {
        pack: 'Paquet',
        pack_number: {
          '1_html': '1 sachet',
          '3_html': '3 sachets',
          '6_html': '6 sachets',
          '12_html': '12 sachets',
          '24_html': '24 sachets',
          default_html: (data: { count: string }) => `${data.count} sachets`,
        },
        discount_html: (data: { percent: string }) =>
          `${data.percent}% de réduction`,
      },
      colli_label: {
        default_html: (data: { count: string }) => `${data.count} pc`,
      },
      add_to_cart: 'Ajouter au panier',
      add_to_cart_sm: 'Ajouter au panier',
      add_to_cart_title: (data: { productTitle: string }) =>
        `Ajouter ${data.productTitle} au panier`,
      new: 'Nouveau',
      quantity: {
        input_label: (data: { product: string }) =>
          `Quantité pour ${data.product}`,
        increase: (data: { product: string }) =>
          `Augmenter la quantité de ${data.product}`,
        decrease: (data: { product: string }) =>
          `Réduire la quantité de ${data.product}`,
        limit_reached_error: (data: {
          totalRequestedQuantity: string
          maxAvailable: string
        }) =>
          `La quantité demandée de ${data.totalRequestedQuantity} n'est pas disponible. La quantité maximale disponible est de ${data.maxAvailable}.`,
        limit_reached_multipack_error: (data: {
          multiplicator: string
          multipackQuantity: string
          availableMultipackQuantity: string
          maxAvailable: string
        }) =>
          `La quantité demandée de ${data.multiplicator}x${data.multipackQuantity} n'est pas disponible. Les multipacks maximum disponibles sont de ${data.availableMultipackQuantity}x${data.multipackQuantity} ou ${data.maxAvailable} produits individuels.`,
        limit_reached_with_cart_items_error: (data: {
          requestedQuantity: string
          cartItemsCount: string
          maxAvailable: string
        }) =>
          `La quantité demandée de ${data.requestedQuantity} n'est pas disponible, car il y a déjà ${data.cartItemsCount} articles dans votre panier. La quantité totale disponible est de ${data.maxAvailable}.`,
        limit_reached_with_cart_items_multipack_error: (data: {
          multiplicator: string
          multipackQuantity: string
          cartItemsCount: string
          maxAvailable: string
        }) =>
          `La quantité demandée de ${data.multiplicator}x${data.multipackQuantity} n'est pas disponible, car il y a déjà ${data.cartItemsCount} articles dans votre panier. La quantité totale disponible de produits individuels est de ${data.maxAvailable}.`,
        minimum_quantity_error: (data: { min: string }) =>
          `Vous devez commander au moins ${data.min} articles.`,
      },
      price: {
        from: 'À partir de',
      },
      sold_out: 'Épuisé',
      diet_disclaimer: 'Selon la recette, contamination croisée possible.',
      sugar_disclaimer: 'Contient naturellement du sucre.',
      salt_disclaimer: 'Contient naturellement du sel.',
      nutrient_data: {
        title: 'Information nutritionnelle',
        'title-average': 'Information nutritionnelle moyenne',
        'per-unit': '100g',
        caloricvalue: 'Pouvoir calorifique (en kj/kcal)',
        fat: 'Graisse',
        fat_of_which_saturates: 'Dont : acides gras saturés',
        fat_of_which_mono_unsaturates: 'dont acides gras mono-insaturés',
        carbohydrate: 'Glucides',
        carbohydrate_of_which_sugars: 'Dont : les sucres',
        carbohydrate_of_which_polyols: 'dont polyols',
        carbohydrate_of_which_starch: 'dont amidon',
        fibre: 'Fibre',
        protein: 'Protéine',
        salt: 'Sel',
        vitamin_e: 'Vitamine E',
        potassium: 'Potassium',
        chloride: 'Chlorure',
        calcium: 'Calcium',
        phosphorus: 'Phosphore',
        omega_3_fatty_acids: 'Les acides gras omega-3',
        magnesium: 'Magnésium',
        iron: 'Fer',
        zinc: 'Zinc',
        copper: 'Cuivre',
        manganese: 'Manganèse',
        fluoride: 'Fluorure',
        selenium: 'Sélénium',
        chromium: 'Chrome',
        molybdenum: 'Molybdène',
        iodine: 'Iode',
        fat_of_which_polyunsaturates: 'dont acides gras polyinsaturés',
        vitamin_a: 'Vitamine A',
        vitamin_d: 'Vitamine D',
        vitamin_k: 'Vitamine K',
        vitamin_c: 'Vitamine C',
        thiamin: 'Thiamine',
        riboflavin: 'Riboflavine',
        niacin: 'Niacine',
        vitamin_b6: 'Vitamine B6',
        folic_acid: 'Acide folique',
        vitamin_b12: 'Vitamine B12',
        biotin: 'Biotine',
        pantothenic_acid: 'Acide pantothénique',
      },
      'filter-p-m-seeberger-diet': {
        label: 'Régime alimentaire',
        'gluten-free': 'sans gluten',
        'lactose-free': 'sans lactose',
        vegan: 'végétalien',
        vegetarian: 'végétarien',
        'no-added-sugar': 'sans sucre ajouté',
        'no-added-salt': 'sans sel ajouté',
      },
    },
    facets: {
      filter_by_label: (data: { filter: string }) => `Filtre: ${data.filter}`,
    },
  },
  sections: {
    cart: {
      remove_title: (data: { title: string }) => `Supprimer ${data.title}`,
      free_gifts: {
        button_label: 'Sélectionnez un cadeau',
        select_label: 'Choisir',
        available_title: 'Votre cadeau vous attend',
        available_title_numbered: (data: { number: string }) =>
          `Votre cadeau n° ${data.number} vous attend`,
        available_text: 'Choisissez maintenant votre cadeau gratuit.',
        change_label: 'Modifier',
        badge_label: 'Cadeau offert',
        progress_bar_label: (data: { remainingMoney: string }) =>
          `Plus que ${data.remainingMoney} avant de recevoir un cadeau.`,
      },
      multipack_discount_hint: {
        tag_next: 'Astuce économie',
        active_text: (data: { percent: string; count: string }) =>
          `-${data.percent}% à partir de ${data.count} pcs`,
        next_text: (data: { percent: string; count: string }) =>
          `-${data.percent}% à partir de ${data.count} pcs`,
      },
    },
    'sb-popup-variant-overlay': {
      select_option: 'Veuillez sélectionner le',
      select_option_zustand: 'Grain entier ou moulu ?',
      select_option_inhalt: 'Combien voudriez-vous?',
      select_option_packung: 'Combien de colis?',
      title: '',
    },
  },
  localization: {
    language_switcher_title: 'Sélection de la langue',
    international: 'International',
    country_section: 'Pays de livraison',
    language_section: 'Langues',
    country_section_desc:
      'Choisissez le pays vers lequel votre livraison doit être envoyée.',
    language_section_desc:
      "Choisissez votre langue préférée pour l'affichage du contenu.",
    redirect_title: 'Redirection',
    redirect_message:
      'Vous serez redirigé vers la version %selection% dans quelques instants.',
    non_order_options: 'Sélection sans possibilité de commande',
  },
  'customer-favorites': {
    'add-to-favorites': 'Ajouter aux Favoris',
    'remove-from-favorites': 'Retirer des favoris',
  },
  subscription: {
    discount_html: (data: { value: string }) => `Économisez ${data.value}`,
  },
} satisfies Locale
